export default "__VITE_ASSET__HUQDuxqb__"